import { getPrinterCapabilities } from './platform';
import type { PrinterModelId } from './printerModelConfig';
import { getXpP203aBluetoothTransport } from './xpP203aBluetoothTransport';

/** Bluetooth Classic Serial Port Profile (RFCOMM) service class ID. */
export const BLUETOOTH_SPP_SERVICE_CLASS_ID = '00001101-0000-1000-8000-00805f9b34fb';

/**
 * Web Serial over Bluetooth RFCOMM (Chrome 117+ desktop, Chrome 138+ Android).
 * Not the same as Web Bluetooth GATT.
 */
export function supportsWebSerialBluetoothSpp(): boolean {
  return getPrinterCapabilities().webSerial;
}

export { xpP203aForceBleGatt } from './xpP203aBluetoothTransport';

/** True when XP-P203A saved transport is RFCOMM serial and Web Serial SPP is available. */
export function shouldUseXpP203aBluetoothSerial(modelId: PrinterModelId): boolean {
  if (modelId !== 'xp-p203a') return false;
  if (!supportsWebSerialBluetoothSpp()) return false;
  return getXpP203aBluetoothTransport() === 'bluetooth-serial';
}
